// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".policy-links[data-v-2b9066bc]{max-width:33rem;margin-left:auto;margin-right:auto}.policy-links .text-xss[data-v-2b9066bc]{font-size:9px}@media (min-width:768px){.policy-links[data-v-2b9066bc]{max-width:unset}.policy-links .text-xss[data-v-2b9066bc]{font-size:12px}}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
